import { useEffect, useState } from 'react';

import GoLockerDropOffDialog from './GoLockerDropOffStatus';

const OPEN_EVENT = 'trashie:golocker-drop-off-status';

/**
 * openGoLockerDropOffStatus({ code } | { batchId }) — THE entry point to the GoLocker
 * drop-off status screen (G5/G6). Opens it over whatever is on screen; the screen then
 * fetches and polls that bag's (or batch's) status by itself, so the caller passes
 * nothing but the identifier.
 *
 * No surface calls it yet: the re-entry card is still being designed. Requires
 * <GoLockerDropOffStatusHost /> to be mounted (App.js mounts it once, inside the
 * Router).
 */
export const openGoLockerDropOffStatus = ({ code, batchId } = {}) => {
  if (!code && !batchId) return;
  window.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: { code, batchId } }));
};

/** The one mounted instance of the status dialog that openGoLockerDropOffStatus drives. */
const GoLockerDropOffStatusHost = () => {
  const [target, setTarget] = useState(null);

  useEffect(() => {
    const onOpen = (event) => setTarget(event.detail ?? null);
    window.addEventListener(OPEN_EVENT, onOpen);
    return () => window.removeEventListener(OPEN_EVENT, onOpen);
  }, []);

  return (
    <GoLockerDropOffDialog
      open={Boolean(target)}
      onClose={() => setTarget(null)}
      code={target?.code}
      batchId={target?.batchId}
    />
  );
};

export default GoLockerDropOffStatusHost;
